document.addEventListener("DOMContentLoaded", async function () {
  const {
    SHOP_NAME,
    STOREFRONT_API_TOKEN,
    HELP_ME_CHOOSE_METAOBJECT_TYPE,
    MARKET_COUNTRY_CODE,
    MONEY_FORMAT,
  } = window.HELP_ME_CHOOSE_CONFIG;
  const {
    HEART_ICON,
    PRODUCT_BADGE: { SOLD_OUT_TEXT, SOLD_OUT_COLOR },
    TICK_ICON,
  } = window.THEME_SETTINGS;

  const currencySymbol = MONEY_FORMAT.replace("{{amount}}", "");
  const PER_PAGE = 12;

  // Main quiz elements
  const quizMainContainer = document.getElementById("quiz__main-container");
  const quizContainer = document.getElementById("quiz__container");
  const quizQuestionEl = document.getElementById("quiz__question");
  const defaultQuestion = quizQuestionEl.dataset.defaultQuestion;
  const globalBackBtn = document.querySelector(
    "#quiz__heading-container .quiz__back-step"
  );
  const navContainer = document.getElementById("quiz__navigation-button");

  // Recommendation elements
  const productRecommendationsDiv = document.getElementById(
    "help-me-choose-recommendation"
  );
  const recommendationProductsContainer = document.getElementById(
    "help-me-choose-recommendation__products"
  );

  // State to track selected answers
  let selectedAnswers = [];
  let selectedTags = [];
  let currentSelection = null;

  // Fetch metaobjects and build the quiz tree
  const helpMeChooseQuery = fetchMetaobjectsByTypeQuery();
  const variables = { type: HELP_ME_CHOOSE_METAOBJECT_TYPE };
  const helpMeChooseData = await shopifyFetch(helpMeChooseQuery, variables);
  const metaobjectTree = buildHelpMeChooseObjectTree(
    helpMeChooseData.metaobjects.nodes
  );

  let lastInteractionWasKeyboard = false;
  document.addEventListener("keydown", (e) => {
    if (e.key === "Tab") {
      lastInteractionWasKeyboard = true;
    }
  });
  document.addEventListener("mousedown", () => {
    lastInteractionWasKeyboard = false;
  });

  // Render a quiz step
  function renderStep(nodes, step = 1, question = null) {
    // Validate nodes
    if (!Array.isArray(nodes) || nodes.length === 0) {
      console.error("No nodes available for this step");
      return;
    }

    quizContainer.innerHTML = "";
    navContainer.innerHTML = "";

    // Set quiz question and back button visibility
    quizQuestionEl.textContent = step > 1 ? question || "" : defaultQuestion;
    globalBackBtn.style.display = step > 1 ? "inline-flex" : "none";

    // Create step container
    const stepDiv = document.createElement("div");
    stepDiv.className = "single-quiz__container";
    stepDiv.dataset.step = step;
    stepDiv.setAttribute("tabindex", "-1");
    stepDiv.focus();

    // Create options container
    const optionsDiv = document.createElement("div");
    optionsDiv.className = "help-me-choose__options";

    nodes.forEach((node) => {
      const optionBtn = createOptionButton(node, stepDiv, step);
      optionsDiv.appendChild(optionBtn);
    });

    // Inserting options into step container
    stepDiv.appendChild(optionsDiv);
    quizContainer.appendChild(stepDiv);

    if (lastInteractionWasKeyboard) {
      const firstButton = optionsDiv.querySelector(
        "button.help-me-choose-option"
      );
      if (firstButton) firstButton.focus();
    }
  }

  // Create an option button element
  function createOptionButton(node, stepDiv) {
    const optionBtn = document.createElement("button");
    optionBtn.className = "help-me-choose-option button";

    const contentDiv = document.createElement("div");
    contentDiv.className = "help-me-choose__option--content";
    const textSpan = document.createElement("span");
    textSpan.textContent = node.title;
    contentDiv.appendChild(textSpan);

    const tickIcon = document.createElement("img");
    tickIcon.src = TICK_ICON;
    tickIcon.alt = "tick icon";
    contentDiv.appendChild(tickIcon);
    optionBtn.setAttribute('title', textSpan.textContent);

    optionBtn.appendChild(contentDiv);

    const overlayDiv = document.createElement("div");
    overlayDiv.className = "help-me-choose__option--overlay";
    optionBtn.appendChild(overlayDiv);

    if (node.image) {
      const img = document.createElement("img");
      img.src = node.image;
      img.alt = node.title;
      optionBtn.prepend(img);
    }

    optionBtn.addEventListener("focus", () => {
      overlayDiv.style.background = `linear-gradient(
    90.63deg,
    #081f2c 22.12%,
    rgba(255, 255, 255, 0) 53.79%,
    rgba(8, 31, 44, 0.6) 78.67%
  )`;
    });
    optionBtn.addEventListener("blur", () => {
      overlayDiv.style.background = "";
    });

    optionBtn.addEventListener("click", () => {
      currentSelection = null;
      currentSelection = node;

      // Remove previous highlight and add to selected answers
      stepDiv
        .querySelectorAll(".help-me-choose-option")
        .forEach((btn) => btn.classList.remove("selected"));
      optionBtn.classList.add("selected");

      // Render next step or show submit button
      renderNavigationButton(node);
    });

    return optionBtn;
  }

  // Create Next or Submit button
  function renderNavigationButton(node) {
    navContainer.innerHTML = "";

    if (node.child?.length) {
      const nextBtn = document.createElement("button");
      nextBtn.className = "quiz__next-step button button--primary";
      nextBtn.textContent = "Next";
      navContainer.appendChild(nextBtn);

      // Add listener for Next button
      nextBtn.addEventListener("click", () => {
        selectedAnswers.push(currentSelection);

        // Render next step
        renderStep(node.child, selectedAnswers.length + 1, node.question);
        // Scroll to top when next button is clicked
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    } else {
      const submitBtn = document.createElement("button");
      submitBtn.className = "quiz__see-results button button--primary";
      submitBtn.textContent = "Submit Answers";
      navContainer.appendChild(submitBtn);

      // Add listener for Submit button
      submitBtn.addEventListener("click", () => {
        selectedTags = [];

        selectedAnswers.push(currentSelection);
        selectedTags = collectTagsFromAnswers(selectedAnswers);
        currentSelection = null;

        // Fetch products by tags and show recommendations
        (async () => {
          const productsByTagsQuery = getProductsByTags(selectedTags);
          const response = await shopifyFetch(
            productsByTagsQuery.query,
            productsByTagsQuery.variables
          );
          setupSubmit(response);
        })();
        // Scroll to top when submit button is clicked
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }
  }

  // Recursively collect product_tag values and return a new array
  function collectTagsFromAnswers(nodes) {
    const tags = [];

    nodes.forEach((node) => {
      if (node.product_tag) tags.push(node.product_tag);
    });

    return tags;
  }

  // Global Back button handler
  if (!globalBackBtn.dataset.bound) {
    globalBackBtn.dataset.bound = "true";
    globalBackBtn.addEventListener("click", () => {
      if (selectedAnswers.length === 0) return;

      // Calculate current step
      let currentStep = selectedAnswers.length + 1;

      // Determine nodes for previous step
      if (currentStep > 2) {
        const previousAnswer = selectedAnswers[selectedAnswers.length - 2];
        // Remove last selected answer
        selectedAnswers.pop();
        renderStep(
          previousAnswer.child,
          currentStep - 1,
          previousAnswer.question
        );
      } else {
        // Remove last selected answer
        selectedAnswers.pop();
        renderStep(metaobjectTree, 1);
      }
    });
  }

  // Initial render
  renderStep(metaobjectTree, 1);

  let isLoading = false;
  let hasNextPage = false;
  let cursor = null;

  /** Handle Submit button logic */
  function setupSubmit(response) {
    const productCount = document.getElementById(
      "help-me-choose-recommendation__count"
    );

    const products = response.products.nodes;
    productCount.innerText = products.length;

    showRecommendations(products);
    setupInfiniteScroll(response);
  }

  /** Hide quiz and show product recommendations */
  function showRecommendations(products) {
    quizMainContainer.style.display = "none";
    productRecommendationsDiv.style.display = "flex";
    recommendationProductsContainer.innerHTML = "";
    renderProducts(products, recommendationProductsContainer);
    createLoadingIndicator();
  }

  /** Create loading indicator element */
  function createLoadingIndicator() {
    const loadingIndicator = document.createElement("div");
    loadingIndicator.id = "loading-indicator";
    loadingIndicator.innerHTML = `
      <div style="
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 20px;
        display: none;
      ">
        <div style="
          border: 3px solid #f3f3f3;
          border-top: 3px solid #5b6770;
          border-radius: 50%;
          width: 30px;
          height: 30px;
          animation: spin 1s linear infinite;
        "></div>
        <span style="margin-left: 10px;">Loading more products...</span>
      </div>
      <style>
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      </style>
    `;

    productRecommendationsDiv.appendChild(loadingIndicator);
  }

  /** Infinite scroll functionality setup */
  function setupInfiniteScroll(response) {
    hasNextPage = response.products.pageInfo.hasNextPage;
    cursor = response.products.pageInfo.endCursor;
    if (hasNextPage) {
      window.addEventListener("scroll", handleScroll);
    }
  }

  /** Handle scroll event for infinite loading */
  async function handleScroll() {
    // Checking if we're near the bottom of the page
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;

    let threshold;
    if (window.innerWidth < 768) {
      threshold = 1500;
    } else if (window.innerWidth < 1200) {
      threshold = 1000;
    } else {
      threshold = 400;
    }

    const nearBottom = scrollTop + windowHeight >= documentHeight - threshold;

    if (nearBottom && hasNextPage && !isLoading) {
      await loadMoreProducts();
    }
  }

  /** Load more products via infinite scroll */
  async function loadMoreProducts() {
    if (isLoading || !hasNextPage) return;
    const productCount = document.getElementById(
      "help-me-choose-recommendation__count"
    );

    isLoading = true;
    const loadingIndicator = document.getElementById("loading-indicator");

    if (loadingIndicator) {
      loadingIndicator.querySelector("div").style.display = "flex";
    }

    try {
      const productsByTagsQuery = getProductsByTags(
        selectedTags,
        MARKET_COUNTRY_CODE,
        cursor
      );
      const moreResponse = await shopifyFetch(
        productsByTagsQuery.query,
        productsByTagsQuery.variables
      );
      const moreProducts = moreResponse.products.nodes;

      productCount.innerText =
        Number(productCount.innerText) + moreProducts.length;

      renderProducts(moreProducts, recommendationProductsContainer);

      // Updating pagination state
      hasNextPage = moreResponse.products.pageInfo.hasNextPage;
      cursor = moreResponse.products.pageInfo.endCursor;

      // Removing scroll listener if no more pages
      if (!hasNextPage) {
        window.removeEventListener("scroll", handleScroll);
        if (loadingIndicator) {
          loadingIndicator.remove();
        }
      }
    } catch (error) {
      console.error("Error loading more products:", error);
    } finally {
      isLoading = false;

      if (loadingIndicator) {
        loadingIndicator.querySelector("div").style.display = "none";
      }
    }
  }

  /**
   * Utility to parse short description from metafield value
   * Metafield value is stored as a JSON string representing rich text
   * This function extracts plain text from it
   **/
  function getShortDescriptionText(rawShortDescriptionValue) {
    if (!rawShortDescriptionValue) return;
    try {
      const parsed = JSON.parse(rawShortDescriptionValue);
      const walk = (node) =>
        node?.type === "text"
          ? node.value || ""
          : Array.isArray(node?.children)
          ? node.children.map(walk).join("")
          : "";
      return walk(parsed);
    } catch {
      return;
    }
  }

  /**
   * Render fetched products into a container
   * @param {Array} products - Array of product objects from Shopify Storefront API
   * @param {HTMLElement} container - DOM element to append product cards into
   */
  function renderProducts(products, container) {
    if (!Array.isArray(products) || !container) return;

    if (products.length === 0) {
      const noResultsDiv = document.querySelector('.hmc-no-results__container');
      if (noResultsDiv) {
        noResultsDiv.style.display = 'block';
      }
    } else {
      products.forEach((product) => {
        const productHtml = `
            <div class="product-card">
              <div class="product-card__image">
                <a href="/products/${
                  product.handle
                }" target="_blank" class="product-card__image-link"></a>
                <img 
                  src="${product.featuredImage?.url || ""}" 
                  alt="${product.title || ""}" 
                  loading="lazy" 
                />
                ${
                  !product.availableForSale
                    ? `
                  <span class="product-badge" style="background-color: ${SOLD_OUT_COLOR}">
                    ${SOLD_OUT_TEXT}
                  </span>
                `
                    : ""
                }
              </div>
              <div class="product-card__meta">
                <div class="product-card__meta-heading">
                  <a href="/products/${product.handle}" target="_blank">
                    <h6 class="product-card__title-text">
                      ${product.title || ""}
                    </h6>
                  </a>
                  <button id="product-card__meta-wishlist">
                    <img src="${HEART_ICON}" alt="wishlist">
                  </button>
                </div>
                <a href="/products/${product.handle}" target="_blank">
                  <span class="product-card__short-description">
                    ${
                      product.short_description?.value
                        ? getShortDescriptionText(
                            product.short_description?.value
                          )
                        : ""
                    }
                  </span>
                </a>
                  <span class="product-card__price">
                    ${currencySymbol}${
          Number(product.variants?.nodes?.[0]?.priceV2?.amount).toFixed(2) || 0
        }
                  </span>
              </div>
            </div>
        `;
  
        container.insertAdjacentHTML("beforeend", productHtml);
      });
    }
  }

  /**
   * Build GraphQL query and variables for fetching products by tags
   * @param {string[]} tags - Array of tags
   * @param {string} countryCode - e.g. "US"
   * @param {string} after - Cursor for pagination
   * @param {number} first - Number of products per page
   * @returns {{query: string, variables: object}}
   */
  function getProductsByTags(
    tags,
    countryCode = MARKET_COUNTRY_CODE,
    after = null,
    first = PER_PAGE
  ) {
    if (!Array.isArray(tags) || tags.length === 0) {
      throw new Error("Please provide at least one tag");
    }

    // Construct query string for tags
    const queryString = tags.map((tag) => `(tag:${tag})`).join(" AND ");

    // GraphQL query
    const query = `
      query getProductsByTags($country: CountryCode!, $first: Int!, $after: String) @inContext(country: $country) {
        products(first: $first, after: $after, query: "${queryString}") {
          nodes {
            id
            title
            handle
            availableForSale
            short_description: metafield(namespace: "short_description", key: "short_description") {
              value
            }
            featuredImage {
              url
              altText
            }
            variants(first: 10) {
              nodes {
                id
                image {
                  url
                  altText
                }
                priceV2 {
                  amount
                  currencyCode
                }
                compareAtPriceV2 {
                  amount
                  currencyCode
                }
              }
            }
          }
          pageInfo {
            hasNextPage
            hasPreviousPage
            endCursor
          }
        }
      }
    `;

    const variables = { country: countryCode, after, first };

    return { query, variables };
  }

  /**
   * Executes a Shopify Storefront GraphQL query with variables.
   **/
  async function shopifyFetch(query, variables = {}) {
    const response = await fetch(
      `https://${SHOP_NAME}/api/2025-07/graphql.json`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token": STOREFRONT_API_TOKEN,
        },
        body: JSON.stringify({ query, variables }),
      }
    );

    const json = await response.json();

    if (json.errors) {
      console.error("Shopify GraphQL errors:", json.errors);
      throw new Error("Shopify GraphQL request failed");
    }

    return json.data;
  }

  /**
   * Build GraphQL query for fetching metaobjects by type
   * @param {string} type - Metaobject type
   * @returns {string} - GraphQL query string
   */
  function fetchMetaobjectsByTypeQuery() {
    const query = `
        query getAllMetaobjects($type: String!) {
          metaobjects(type: $type, first: 250) {
            nodes {
              id
              title: field(key: "title") { value }
              product_tag: field(key: "product_tag") { value }
              question: field(key: "question") { value }
              image: field(key: "image") {
                  reference {
                      ... on MediaImage {
                          image {
                              url
                          }
                      }
                  }
              }
              child_options: field(key: "child_options") {
                references(first: 10) {
                  nodes {
                    ... on Metaobject {
                      id
                      title: field(key: "title") { value }
                      product_tag: field(key: "product_tag") { value }
                      question: field(key: "question") { value }
                      image: field(key: "image") {
                          reference {
                              ... on MediaImage {
                                  image {
                                      url
                                  }
                              }
                          }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      `;

    return query;
  }

  function buildHelpMeChooseObjectTree(metaobjects) {
    const map = new Map();
    const roots = [];

    // Prepare nodes map
    metaobjects.forEach((obj) => {
      map.set(obj.id, {
        id: obj.id,
        title: obj.title?.value || null,
        product_tag: obj.product_tag?.value || null,
        question: obj.question?.value || null,
        image: obj.image?.reference?.image?.url || null,
        child: [],
      });
    });

    // Build parent-child relationships
    metaobjects.forEach((obj) => {
      const node = map.get(obj.id);
      if (obj.child_options?.references?.nodes) {
        obj.child_options.references.nodes.forEach((childRef) => {
          const childNode = map.get(childRef.id);
          if (childNode) {
            node.child.push(childNode);
          }
        });
      }
    });

    // Identify roots (nodes that are not anyone's child)
    const allChildIds = new Set();
    metaobjects.forEach((obj) => {
      obj.child_options?.references?.nodes.forEach((childRef) =>
        allChildIds.add(childRef.id)
      );
    });

    metaobjects.forEach((obj) => {
      if (!allChildIds.has(obj.id)) {
        roots.push(map.get(obj.id));
      }
    });

    return roots;
  }
});
